export default __webpack_public_path__ + "img/empty-edit-placeholder.232473b9.svg";